import { Component, input } from '@angular/core';

@Component({
  selector: 'rt-evaluation-field-label',
  templateUrl: './evaluation-field-label.component.html',
  styleUrls: ['./evaluation-field-label.component.less'],
})
export class EvaluationFieldLabelComponent {
  public readonly title = input<string>('');
  public readonly hint = input<string>('');
  public readonly required = input<boolean>(false);
  public readonly filled = input<boolean>(false);
}
